import {
  Accordion,
  Button,
  CheckboxGroup,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Link,
  Select,
  Spinner,
  Stack,
  Td,
  Text,
  Textarea,
  Tooltip,
  Tr,
  useToast,
} from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FieldValues, useForm } from 'react-hook-form';
import { TextL, TextXS } from '../../../../components/Text/Index';
import AccordionTemplate from '../../../../components/AccordionTemplate/Index';
import MessageError from '../../../../components/MessageError';
import { useRequestGetSpecialCondition } from '../../../../services/hooks/SpecialCondition/useGetSpecialCondition';
import { useEffect } from 'react';

import { useRequestUpdateSpecialCondition } from '../../../../services/hooks/SpecialCondition/usePatchSpecialCondition';
import TableCustom from '../../../../components/pages/CandidateArea/Table';
import { useRequestGetDataToRegistration } from '../../../../services/hooks/CandidateArea/useGetDataToRegistration';
import { useGetRegistration } from '../../../../services/hooks/Registration/useGetRegistration';
import { validadeFileName, validateTypeFile, validationSizeFile } from '../../../../utils/validationForm';
import { handleDeleteAttach } from '../../../../utils/functions';

const ComponentSpecialCondition: React.FC = () => {
  const registrationId = useLocation().pathname.split('/')[3];
  const selectiveProcessId = useLocation().pathname.split('/')[4];
  const navigate = useNavigate();
  const specialConditionData = useRequestGetSpecialCondition(registrationId || '');
  const toast = useToast();
  const attachSpecialCondition = ['Arquivo', 'Data de envio', 'Ações'];
  const selectiveProcessData = useRequestGetDataToRegistration(selectiveProcessId);
  const patchSpecialCondition = useRequestUpdateSpecialCondition();
  const registrationData = useGetRegistration(registrationId);

  const schema = Yup.object().shape({
    has_special_condition: Yup.string().required('Campo obrigatorio'),
    attachmentFile: Yup.array(),
    observation: Yup.array(),
    selectedSpecialCondition: Yup.array()
      .test('isRequired', 'Selecione ao menos uma atendimento especial', (specialConditionList) => {
        let isEmpty = false;

        if (!(hookForms.getValues('has_special_condition') === 'yes')) return true;

        specialConditionList?.forEach((modality) => {
          if (modality !== false) {
            isEmpty = true;
            return;
          }
        });

        return isEmpty;
      })
      .test('isRequired', '', (specialConditionList) => {
        if (!(hookForms.getValues('has_special_condition') === 'yes')) return true;

        const validationError: Yup.ValidationError[] = [];

        specialConditionList?.forEach((modality, index) => {
          if (modality !== false) {
            const observation: string = hookForms.getValues(`observation.${index}`);
            if (observation?.length === 0) {
              if (!selectiveProcessData.data?.special_condition[index].is_social_name) {
                validationError.push(
                  new Yup.ValidationError('Campo Obrigatorio', specialConditionList[index], `observation.${index}`),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }

        return true;
      })
      .test('isRequired', 'Campo obrigatório', (specialConditionList) => {
        if (registrationId) {
          const validationError: Yup.ValidationError[] = [];

          specialConditionList?.forEach((modality, index) => {
            const specialConditionDataToRegistration = selectiveProcessData.data?.special_condition.find(
              (sp) => sp.id === modality,
            );

            if (modality !== false) {
              const file: FileList = hookForms.getValues(`attachmentFile.${index}`);
              const spc = registrationData.data?.special_conditions.find((sp) => sp?.id === modality);
              if (spc?.attachments && spc?.attachments?.length > 0) {
                if (file?.length === 0 && registrationData.data?.special_conditions[index]?.attachments?.length === 0) {
                  if (specialConditionDataToRegistration?.has_attachment) {
                    validationError.push(
                      new Yup.ValidationError(
                        'Selecione um arquivo para continuar',
                        specialConditionList[index],
                        `attachmentFile.${index}`,
                      ),
                    );
                  } else {
                    return true;
                  }
                }

                return true;
              } else if (file?.length === 0 && specialConditionDataToRegistration?.has_attachment) {
                validationError.push(
                  new Yup.ValidationError(
                    'Selecione um arquivo para continuar',
                    specialConditionList.filter((sp) => sp !== false)[index],
                    `attachmentFile.${index}`,
                  ),
                );
                return;
              }
            }
          });
          if (validationError?.length > 0) {
            throw new Yup.ValidationError(validationError);
          }
          return true;
        }

        if (!registrationId) {
          const validationError: Yup.ValidationError[] = [];
          specialConditionList?.forEach((modality, index) => {
            const specialConditionDataToRegistration = selectiveProcessData.data?.special_condition.find(
              (sp) => sp.id === modality,
            );
            if (modality !== false) {
              const file: FileList = hookForms.getValues(`attachmentFile.${index}`);
              if (file?.length === 0 && specialConditionDataToRegistration?.has_attachment) {
                validationError.push(
                  new Yup.ValidationError(
                    'Selecione um arquivo para continuar',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          });
          if (validationError?.length > 0) {
            throw new Yup.ValidationError(validationError);
          }
          return true;
        }
      })
      .test('TypeFile', 'Tipo de arquivo nao suportado', (specialConditionList) => {
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];
        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const file: FileList = hookForms.getValues(`attachmentFile.${index}`);
            if (file?.length > 0) {
              const response = validateTypeFile(file);
              if (!response) {
                validationError.push(
                  new Yup.ValidationError(
                    'Tipo de arquivo nao suportado',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('MaxFileSize', '', (specialConditionList) => {
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];
        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const file: FileList = hookForms.getValues(`attachmentFile.${index}`);
            if (file?.length > 0) {
              const response = validationSizeFile(file);
              if (!response) {
                validationError.push(
                  new Yup.ValidationError(
                    'Tamanho máximo para arquivos é de 2MB',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('MaxFile', 'Quantidade maxima de arquivos atingida (5)', (specialConditionList) => {
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];

        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const attach = hookForms.getValues(`attachmentFile.${index}`);
            if (attach && attach?.length > 0) {
              registrationData.data?.special_conditions.forEach((value) => {
                if (value.id === modalityListFile) {
                  const file = value?.attachments?.length || 0;
                  if (file > 4) {
                    validationError.push(
                      new Yup.ValidationError(
                        'Quantidade maxima de arquivos atingida (5)',
                        specialConditionList[index],
                        `attachmentFile.${index}`,
                      ),
                    );
                  }
                }
              });
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('FileName', 'Nome de arquivo invalido', (specialConditionList) => {
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];

        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const attach = hookForms.getValues(`attachmentFile.${index}`);
            if (attach?.length > 0) {
              const file = validadeFileName(attach);

              if (!file) {
                validationError.push(
                  new Yup.ValidationError(
                    'Nome do arquivo invalido',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      }),
  });

  const hookForms = useForm({
    resolver: yupResolver(schema),
  });

  const newSpecialCondition = async (data: FieldValues) => {
    patchSpecialCondition
      .mutateAsync({
        data: data,
        registrationId: registrationId || '',
        specialCondition: specialConditionData?.data?.special_conditions,
      })
      .then(() => {
        toast({
          title: 'Sucesso',
          description: 'Condições especiais alteradas com sucesso',
          status: 'success',
          duration: 4000,
          isClosable: true,
        });
        navigate('/painel/inscricoes');
      })
      .catch(() => {
        toast({
          title: 'Erro',
          description: 'Erro na solicitação, tente novamente mais tarde',
          status: 'error',
          duration: 4000,
          isClosable: true,
        });
      });
  };

  const renderFilename = (idx: number) => {
    const files: FileList = hookForms.watch(`attachmentFile.${idx}`);
    const listFileName: string[] = [];

    if (!files || files.length === 0) {
      return ['Envie seus arquivos'];
    } else {
      for (let index = 0; index < files.length; index++) {
        listFileName.push(files[index]?.name || 'Sem_nome');
      }
    }

    return listFileName;
  };

  useEffect(() => {
    hookForms.setValue('has_special_condition', 'no');
    specialConditionData.data?.special_conditions.map((condition, index) => {
      if (condition.checked) hookForms.setValue('has_special_condition', 'yes');
      hookForms.setValue(`selectedSpecialCondition.${index}`, condition?.checked),
        hookForms.setValue(`observation.${index}`, condition?.observations || '');
    });
  }, [specialConditionData.data]);

  // const handleDeleteAttach = (attachmentId: string) => {
  //   configApi
  //     .delete(`/attachment/delete/${attachmentId}/`)
  //     .then(() => {
  //       toast({
  //         title: 'Sucesso',
  //         description: 'Anexo excluido com sucesso',
  //         status: 'success',
  //         duration: 4000,
  //         isClosable: true,
  //       });
  //       specialConditionData.refetch();
  //     })
  //     .catch(() => {
  //       toast({
  //         title: 'Erro',
  //         description: 'Erro na solicitação, tente novamente mais tarde',
  //         status: 'error',
  //         duration: 4000,
  //         isClosable: true,
  //       });
  //     });
  // };

  const deleteAttachment = async (fileId: string) => {
    await handleDeleteAttach(fileId, toast, registrationData.refetch).then(() => {});
  };

  return (
    <Flex
      as="form"
      onSubmit={hookForms.handleSubmit(newSpecialCondition)}
      flexDir="column"
      px={['10px', '10px', '10px', '50px', '50px']}
      gap={10}
    >
      <Stack>
        <TextL>{specialConditionData?.data?.title}</TextL>
        <TextXS>
          <strong>Nome: </strong>
          {specialConditionData?.data?.candidate}
        </TextXS>
        <TextXS>
          <strong>Inscrição: </strong>
          {specialConditionData?.data?.registration_code}
        </TextXS>
        <TextXS>
          <strong>Vaga: </strong>
          {specialConditionData?.data?.selective_process_vacancy}
        </TextXS>
        <TextXS>
          <strong>Modalidade: </strong>
          {specialConditionData?.data?.type_of_competition}
        </TextXS>
      </Stack>
      <Stack>
        <Accordion display="flex" flexDir="column" gap={2} allowMultiple defaultIndex={[0, 1, 2, 3, 4]}>
          <AccordionTemplate
            border="1px solid"
            borderColor="primaryColor"
            borderRadius={6}
            title="ATENDIMENTO ESPECIAL"
          >
            <Flex flexDir={['column', 'column', 'column', 'column', 'column']}>
              <FormLabel fontSize="14px" fontWeight="semibold">
                Você deseja informar algum atendimento especial?
              </FormLabel>
              <Stack align="center" w="100%">
                <Grid gridTemplateColumns="repeat(3, 1fr)" w="100%">
                  <FormControl textAlign="center">
                    <Select {...hookForms.register('has_special_condition')}>
                      <option value="" hidden>
                        Selecione...
                      </option>
                      <option value="yes">Sim</option>
                      <option value="no">Não</option>
                    </Select>
                    {hookForms.formState.errors.has_special_condition && (
                      <MessageError>{hookForms.formState.errors.has_special_condition?.message}</MessageError>
                    )}
                  </FormControl>
                </Grid>

                {hookForms.watch('has_special_condition') === 'yes' && (
                  <CheckboxGroup>
                    <Stack w="100%" gap={0} direction={['column']}>
                      {(selectiveProcessData?.data?.special_condition &&
                        selectiveProcessData?.data?.special_condition.map((condition, index) => (
                          <Stack
                            key={condition.id}
                            p={hookForms.watch(`selectedSpecialCondition.${index}`) ? 4 : 1}
                            transition="0.4s"
                            bg={hookForms.watch(`selectedSpecialCondition.${index}`) ? 'lightGrey' : 'white'}
                          >
                            <label htmlFor={`${index}`}>
                              <input
                                id={`special-condition-${condition.id}`}
                                style={{
                                  border: '2px solid #ff0000',
                                  width: '16px',
                                  height: '16px',
                                  marginRight: 7,
                                }}
                                type="checkbox"
                                {...hookForms.register(`selectedSpecialCondition.${index}`)}
                                value={condition.id}
                              />
                              {condition.name}
                            </label>

                            {hookForms.watch(`selectedSpecialCondition.${index}`) && (
                              <Stack borderRadius={10}>
                                {!condition.is_social_name && (
                                  <Textarea
                                    p={3}
                                    placeholder="Descreva em detalhes a sua necessidade."
                                    {...hookForms.register(`observation.${index}`)}
                                    bg="white"
                                    h="100px"
                                  />
                                )}

                                {hookForms.formState.errors.observation && (
                                  <MessageError>
                                    {hookForms.formState?.errors?.observation[index]?.message?.toString()}
                                  </MessageError>
                                )}

                                <Stack>
                                  <Flex align="center">
                                    <Text
                                      bg="primaryColor"
                                      color="white"
                                      w="fit-content"
                                      as="label"
                                      htmlFor={`file-${index}`}
                                      py={1.5}
                                      px={3}
                                      borderRadius={5}
                                      cursor="pointer"
                                    >
                                      Selecionar arquivo
                                    </Text>

                                    {renderFilename(index).map((filename, idx) => {
                                      return filename.length < 30 ? (
                                        <TextXS key={idx} ml={4}>
                                          {filename}
                                        </TextXS>
                                      ) : (
                                        <Tooltip key={idx} label={filename}>
                                          <TextXS
                                            ml={4}
                                          >{`${filename.substring(0, 20)}...${filename.slice(-8)}`}</TextXS>
                                        </Tooltip>
                                      );
                                    })}

                                    <Input
                                      alignContent="center"
                                      {...hookForms.register(`attachmentFile.${index}`)}
                                      type="file"
                                      id={`file-${index}`}
                                      w="fit-content"
                                      pl={0}
                                      border="none"
                                      display="none"
                                      multiple
                                    />
                                    {hookForms.formState.errors.attachmentFile && (
                                      <MessageError ml={2}>
                                        {hookForms.formState?.errors?.attachmentFile[index]?.message?.toString()}
                                      </MessageError>
                                    )}
                                  </Flex>
                                  {registrationData.data?.special_conditions
                                    .filter((sp) => condition.id === sp.id)
                                    .map((attach) => (
                                      <Stack>
                                        <TableCustom headers={attachSpecialCondition}>
                                          {(attach.attachments?.length > 0 &&
                                            attach.attachments?.map((files) => (
                                              <Tr key={index} textAlign="center">
                                                <Td textAlign="center">
                                                  <Link
                                                    fontSize="14px"
                                                    color="colorLink"
                                                    target="_blank"
                                                    href={files.url}
                                                  >
                                                    {files.name}
                                                  </Link>
                                                </Td>
                                                <Td textAlign="center">
                                                  <TextXS>{`${files.created_at}`}</TextXS>
                                                </Td>
                                                <Td textAlign="center">
                                                  {condition?.has_attachment && attach.attachments.length > 1 ? (
                                                    <TextXS
                                                      cursor={'pointer'}
                                                      onClick={() => deleteAttachment(files.id)}
                                                      color="colorLink"
                                                    >
                                                      Excluir
                                                    </TextXS>
                                                  ) : (
                                                    !condition.has_attachment && (
                                                      <TextXS
                                                        cursor={'pointer'}
                                                        onClick={() => deleteAttachment(files.id)}
                                                        color="colorLink"
                                                      >
                                                        Excluir
                                                      </TextXS>
                                                    )
                                                  )}
                                                </Td>
                                              </Tr>
                                            ))) || (
                                            <Tr>
                                              <Td textAlign="center" colSpan={3}>
                                                Nenhum arquivo enviado!
                                              </Td>
                                            </Tr>
                                          )}
                                        </TableCustom>
                                      </Stack>
                                    ))}
                                </Stack>
                              </Stack>
                            )}
                          </Stack>
                        ))) || <MessageError>Sem dados...</MessageError>}
                      <MessageError>{hookForms.formState.errors.selectedSpecialCondition?.root?.message}</MessageError>
                    </Stack>
                  </CheckboxGroup>
                )}
              </Stack>
            </Flex>
          </AccordionTemplate>
        </Accordion>

        <Stack flexDir="row" justify="flex-end" py={5}>
          <Button
            w={'100px'}
            onClick={() => {
              navigate('/');
            }}
          >
            Cancelar
          </Button>
          <Button
            isDisabled={patchSpecialCondition?.isPending}
            type="submit"
            bg="colorLink"
            color="white"
            w={'100px'}
            _hover={'none'}
          >
            {patchSpecialCondition?.isPending ? <Spinner /> : 'Continuar'}
          </Button>
        </Stack>
      </Stack>
    </Flex>
  );
};

export default ComponentSpecialCondition;
